<!-- Sidebar -->
<ul class="navbar-nav bg-gradient-dark sidebar sidebar-dark accordion h-100" id="accordionSidebar">

  <!-- Sidebar - Brand -->
  <a class="sidebar-brand d-flex align-items-center justify-content-center" (click)="nav('/all')">
    <div class="sidebar-brand-icon">
      <img src="assets/img/logo_white.png" alt="" style="max-width: 10vw;">
    </div>
  </a>



  <!-- Nav Item - Dashboard -->
  <li class="nav-item active">
    <a class="nav-link" (click)="nav('/all')">
      <i class="fas fa-fw fa-tachometer-alt"></i>
      <span>Dashboard</span></a>
  </li>

  <!-- Divider -->
  <hr class="sidebar-divider">

  <!-- Heading -->
  <div class="sidebar-heading">
    Menu
  </div>

  <!-- Nav Item - Pages Collapse Menu -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true"
      aria-controls="collapseTwo">
      <i class="fas fa-user"></i>
      <span>Fichas</span>
    </a>
    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Menu Fichas:</h6>
        <a class="collapse-item" (click)="nav('/crear')">Crear</a>
        <a class="collapse-item" (click)="nav('/all')">Ver Todas</a>
        <a class="collapse-item" (click)="nav('/peticiones')">Peticiones</a>
        <a class="collapse-item" (click)="nav('/loginrecords')">Login Records</a>
      </div>
    </div>
  </li>

  <!-- Nav Item - Utilities Collapse Menu -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseUtilities" aria-expanded="true"
      aria-controls="collapseUtilities">
      <i class="fas fa-fw fa-wrench"></i>
      <span>Utilidades</span>
    </a>
    <div id="collapseUtilities" class="collapse" aria-labelledby="headingUtilities" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Utilidades:</h6>
        <a class="collapse-item" (click)="nav('/zonas')">Zonas</a>
        <a class="collapse-item" (click)="nav('/tags')">Tags</a>
        <a class="collapse-item" (click)="nav('/paquetes')">Paquetes</a>
        <a class="collapse-item" (click)="nav('/noticias')">Noticias</a>
        <!-- <a class="collapse-item" href="utilities-animation.html">Animations</a>
          <a class="collapse-item" href="utilities-other.html">Other</a> -->
      </div>
    </div>
  </li>

  <!-- Divider -->
  <!-- <hr class="sidebar-divider"> -->

  <!-- Heading -->
  <!-- <div class="sidebar-heading">
      Addons
    </div> -->

  <!-- Nav Item - Pages Collapse Menu -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapsePages" aria-expanded="true"
      aria-controls="collapsePages">
      <i class="fas fa-dollar-sign"></i>
      <span>Finanzas</span>
    </a>
    <div id="collapsePages" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Menu Finanzas:</h6>
        <a class="collapse-item" (click)="nav('/general-finances')">Finanzas General</a>
        <a class="collapse-item" (click)="nav('/nextvencimientos')">Proximos vencimientos</a>
        <a class="collapse-item" (click)="nav('/listadoletras')">Letras</a>
        <a class="collapse-item" (click)="nav('/all')">Fichas Deudoras</a>
        <a class="collapse-item" (click)="nav('/last-inputs')">Realizar Ingreso</a>
        <a class="collapse-item" (click)="nav('/add-paquetes')">Agregar Tiempo</a>        
      </div>
    </div>
  </li>

  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true"
      aria-controls="collapseTwo">
      <i class="fas fa-user-shield"></i>
      <span>Admins</span>
    </a>
    <div id="collapseFour" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Menu Admins:</h6>
        <a class="collapse-item" (click)="nav('/admin')">Crear Nuevo</a>
        <!-- <a class="collapse-item" (click)="nav('/all')">Ver Todas</a> -->
      </div>
    </div>
  </li>


  <!-- Divider -->
  <hr class="sidebar-divider d-none d-md-block mt-5">

  <li class="nav-item">
    <a class="nav-link"  (click)="change()" >
      <i class="fas fa-sign-out-alt"></i>
      <span>Cambiar de Ciudad</span></a>
  </li>

  <hr class="sidebar-divider d-none d-md-block mt-5">

  <!-- Nav Item - Tables -->
  <li class="nav-item">
    <a class="nav-link"  (click)="Logout()" >
      <i class="fas fa-sign-out-alt"></i>
      <span>Logout</span></a>
  </li>

  <!-- Sidebar Toggler (Sidebar) -->
  <!-- <div class="text-center d-none d-md-inline">
      <button class="rounded-circle border-0" id="sidebarToggle"></button>
    </div> -->

  <!-- Sidebar Message -->
  <!-- <div class="sidebar-card">
      <img class="sidebar-card-illustration mb-2" src="img/undraw_rocket.svg" alt="">
      <p class="text-center mb-2"><strong>SB Admin Pro</strong> is packed with premium features, components, and more!</p>
      <a class="btn btn-success btn-sm" href="https://startbootstrap.com/theme/sb-admin-pro">Upgrade to Pro!</a>
    </div> -->

</ul>
<!-- End of Sidebar -->
